import { useNavigate } from '@fukuri-admins/hooks/common';
import clsx from 'clsx';
import React from 'react';
import { ServiceListType, ServiceType } from '../../../types/resources/ServiceType';
import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../types/table/ActionTableSortParamsType';
import { getServiceLink } from '../../../utils/getLinks';
import { TableRoot } from '../../common/Table/TableBase/TableRoot';
import styles from './styles.module.scss';

interface ServiceTableContentProps {
  columns: ActionTableColumnsType[];
  rows: ServiceListType;
  sortParams: ActionTableSortParamsType;
  headerSort: (column: string) => void;
}

export const ServiceTableContent: React.FC<ServiceTableContentProps> = ({
  columns,
  rows,
  sortParams,
  headerSort,
}) => {
  const navigate = useNavigate();

  const getNestedValue = (obj: ServiceType, path: string) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
  };

  const tableRows =
    rows !== undefined ? (
      rows.map((row: ServiceType, key: number) => (
        <tr
          key={key}
          className={clsx(styles.tableRow)}
          onClick={() => {
            navigate(getServiceLink(row.id));
          }}
          data-testid={`table-row-${key}`}
        >
          {columns.map((column, columnIndex) => (
            <td
              key={column.key}
              className={clsx(styles.tableCell, {
                [styles.clickable]: column.sortable,
              })}
              onClick={() => {
                if (column.sortable) {
                  headerSort(column.key);
                }
              }}
              data-testid={`table-cell-${columnIndex === 0 ? 'no' : column.key}`}
            >
              {column.key === 'title' || column.key === 'overview'
                ? row[column.key]?.length > 20
                  ? `${row[column.key].slice(0, 20)}...`
                  : row[column.key]
                : (getNestedValue(row, column.key) ?? '-')}
            </td>
          ))}
        </tr>
      ))
    ) : (
      <></>
    );

  return (
    <>
      {rows?.length === 0 || rows === null ? (
        <div className={styles.emptyTable}>データなし</div>
      ) : (
        <TableRoot
          columns={columns}
          rows={tableRows}
          sortParams={sortParams}
          onClickHeader={column => headerSort(column)}
        />
      )}
    </>
  );
};
